import { render, staticRenderFns } from "./laonlsec.vue?vue&type=template&id=a2bf2246&"
import script from "./laonlsec.vue?vue&type=script&lang=js&"
export * from "./laonlsec.vue?vue&type=script&lang=js&"
import style0 from "./laonlsec.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports